import TravelClassSeatCountInterface from '../../interfaces/client/TravelClassSeatCount'

import constants from '../../config/constants'

const { smartTravelClass } = constants

export default (travelClassSeatCount: TravelClassSeatCountInterface) =>
  travelClassSeatCount.travelClass === smartTravelClass
